function _array_like_to_array(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}
function _array_with_holes(arr) {
  if (Array.isArray(arr)) return arr;
}
function _define_property(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _iterable_to_array_limit(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _s, _e;
  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);
      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }
  return _arr;
}
function _non_iterable_rest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys.forEach(function (key) {
      _define_property(target, key, source[key]);
    });
  }
  return target;
}
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _object_spread_props(target, source) {
  source = source != null ? source : {};
  if (Object.getOwnPropertyDescriptors) {
    Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
  } else {
    ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _sliced_to_array(arr, i) {
  return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _array_like_to_array(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(n);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import { Html, OverlaysQuery, OverlayType } from "@custom/schema";
import { CloseButton, Dialog, DialogPanel } from "@headlessui/react";
import clsx from "clsx";
import React, { useEffect, useState } from "react";
import { ArrowRight, X } from "react-feather";
import { useTranslation } from "react-i18next";
import { useDomain } from "../../../utils/domain";
import { isTruthy } from "../../../utils/isTruthy";
import { useLocalization } from "../../../utils/localization";
import { useOperation } from "../../../utils/operation";
import { Button } from "../../Atoms/Button";
import { Image, transformImageFragmentToProps } from "../../Atoms/Image";
import { LinkItem } from "../../Atoms/Link";
import { LinkClickHandler } from "../../Atoms/LinkClickHandler";
export var Overlays = function Overlays() {
  var _overlayQuery_data_fetchAllOverlays, _overlayQuery_data;
  var domain = useDomain();
  var locale = useLocalization().locale;
  var overlayQuery = useOperation(OverlaysQuery);
  return /*#__PURE__*/React.createElement(React.Fragment, null, (_overlayQuery_data = overlayQuery.data) === null || _overlayQuery_data === void 0 ? void 0 : (_overlayQuery_data_fetchAllOverlays = _overlayQuery_data.fetchAllOverlays) === null || _overlayQuery_data_fetchAllOverlays === void 0 ? void 0 : _overlayQuery_data_fetchAllOverlays.filter(function (overlay) {
    var _overlay_domainAccess;
    return (overlay === null || overlay === void 0 ? void 0 : (_overlay_domainAccess = overlay.domainAccess) === null || _overlay_domainAccess === void 0 ? void 0 : _overlay_domainAccess.some(function (overlayDomain) {
      return (overlayDomain === null || overlayDomain === void 0 ? void 0 : overlayDomain.id) === domain.id;
    })) && (overlay === null || overlay === void 0 ? void 0 : overlay.locale) === (locale || locale);
  }).filter(isTruthy).map(function (overlay) {
    return /*#__PURE__*/React.createElement(Overlay, _object_spread({
      key: "overlay-".concat(overlay.id)
    }, overlay));
  }));
};
export var setClosedOverlay = function setClosedOverlay(overlayId) {
  if (typeof window === "undefined" || typeof localStorage === "undefined") {
    return;
  }
  var currentTimeSeconds = Math.floor(new Date().getTime() / 1000);
  var closedOverlays = JSON.parse(localStorage.getItem("closedOverlays") || "{}");
  closedOverlays[overlayId] = {
    closedAt: currentTimeSeconds
  };
  localStorage.setItem("closedOverlays", JSON.stringify(closedOverlays));
};
export var displayOverlay = function displayOverlay(id) {
  var interval = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
  if (!id || typeof window === "undefined" || typeof localStorage === "undefined") {
    return false;
  }
  var closedOverlays = JSON.parse(localStorage.getItem("closedOverlays") || "{}");
  var currentTimeSeconds = Math.floor(new Date().getTime() / 1000);
  var intervalInSeconds = interval * 3600;
  return !closedOverlays[id] || intervalInSeconds > 0 && currentTimeSeconds > intervalInSeconds + closedOverlays[id].closedAt;
};
export var Overlay = function Overlay(props) {
  var _useState = _sliced_to_array(useState(false), 2),
    doDisplayOverlay = _useState[0],
    setDoDisplayOverlay = _useState[1];
  var hasOverlay = displayOverlay(props.id, props.overlayInterval);
  useEffect(function () {
    setDoDisplayOverlay(hasOverlay);
  }, [hasOverlay]);
  var hasCloseButton = props.overlayType !== OverlayType.CrisisOverlay;
  return /*#__PURE__*/React.createElement(LinkClickHandler, {
    onLinkClick: function onLinkClick() {
      setClosedOverlay(props.id);
      setDoDisplayOverlay(false);
    }
  }, /*#__PURE__*/React.createElement(Dialog, {
    open: doDisplayOverlay,
    onClose: function onClose() {
      setClosedOverlay(props.id);
      setDoDisplayOverlay(false);
    },
    className: "relative z-50"
  }, /*#__PURE__*/React.createElement("div", {
    className: clsx("fixed inset-0", props.overlayType === OverlayType.TransparentOverlay && "bg-primary-black/60 backdrop-blur-[18px]"),
    "aria-hidden": "true"
  }), /*#__PURE__*/React.createElement(DialogPanel, {
    className: clsx("fixed inset-0 flex items-center justify-center", props.overlayType !== OverlayType.TransparentOverlay && "h-full w-full bg-primary-beige-light")
  }, /*#__PURE__*/React.createElement("div", {
    className: clsx("w-full h-full overflow-auto", hasCloseButton ? "max-md:pt-20" : "max-md:pt-8")
  }, (props.overlayType === OverlayType.CrisisOverlay || props.overlayType === OverlayType.FullOverlay) && /*#__PURE__*/React.createElement(FullScreenOverlay, props), props.overlayType === OverlayType.FloatingboxOverlay && /*#__PURE__*/React.createElement(FloatingOverlay, props), props.overlayType === OverlayType.TransparentOverlay && /*#__PURE__*/React.createElement(TransparentOverlay, props), hasCloseButton && /*#__PURE__*/React.createElement(CloseButton, {
    className: "bg-primary-white p-2.5 rounded-b-lg text-primary-black hover:text-theme-action absolute right-10 top-0 transition-colors duration-300 ease-in-out",
    onClick: function onClick() {
      setClosedOverlay(props.id);
      setDoDisplayOverlay(false);
    },
    "aria-label": "Close Overlay"
  }, /*#__PURE__*/React.createElement(X, {
    className: "h-9 w-9 stroke-[1.5]",
    "aria-hidden": true
  }))))));
};
/** used for both full and crisis overlays */
var FullScreenOverlay = function FullScreenOverlay(props) {
  var _props_overlayMoreLink;
  return /*#__PURE__*/React.createElement("div", {
    className: "md:grid flex flex-col md:grid-cols-2 gap-10 md:gap-[50px] md:py-10 h-full w-full max-md:pe-4"
  }, /*#__PURE__*/React.createElement("div", {
    className: "relative w-full md:h-full rounded-r-7.5 overflow-hidden md:min-h-[600px] min-h-[200px] h-60"
  }, /*#__PURE__*/React.createElement(Image, _object_spread_props(_object_spread({
    className: "absolute inset-0 w-full h-full"
  }, transformImageFragmentToProps(props.overlayImage, ["breaking_news_portrait"])), {
    fit: true
  }))), /*#__PURE__*/React.createElement("div", {
    className: "max-md:ps-4 flex md:items-center pe-[50px]"
  }, /*#__PURE__*/React.createElement(OverlayInfoBox, _object_spread({
    title: props.overlayTitle,
    subtitle: props.overlaySubTitle,
    text: props.overlayText
  }, props.overlayType !== OverlayType.CrisisOverlay && {
    url: (_props_overlayMoreLink = props.overlayMoreLink) === null || _props_overlayMoreLink === void 0 ? void 0 : _props_overlayMoreLink.url,
    linkLabel: props.overlayMoreText
  }))));
};
var FloatingOverlay = function FloatingOverlay(props) {
  var _props_overlayMoreLink;
  return /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col md:grid md:grid-cols-2 h-full w-full items-center px-4 md:ps-10 md:pe-2 container-content"
  }, /*#__PURE__*/React.createElement("div", {
    className: "relative w-full md:h-1/2 h-60 md:min-h-[500px] md:max-h-[600px] overflow-hidden max-md:z-[60] "
  }, /*#__PURE__*/React.createElement(Image, _object_spread_props(_object_spread({
    className: "absolute inset-0 w-full h-full"
  }, transformImageFragmentToProps(props.overlayImage, ["small", "medium", "large"])), {
    size: "large",
    fit: true
  }))), /*#__PURE__*/React.createElement("div", {
    className: " pt-10 pb-7 px-6 md:pe-10 md:py-12 md:ps-20 bg-primary-white rounded-l-7.5 md:rounded-7.5 w-full md:h-fit max-md:translate-x-4 md:-translate-x-8 max-md:-translate-y-5"
  }, /*#__PURE__*/React.createElement(OverlayInfoBox, {
    title: props.overlayTitle,
    subtitle: props.overlaySubTitle,
    text: props.overlayText,
    url: (_props_overlayMoreLink = props.overlayMoreLink) === null || _props_overlayMoreLink === void 0 ? void 0 : _props_overlayMoreLink.url,
    linkLabel: props.overlayMoreText,
    ctaType: "link"
  })));
};
var TransparentOverlay = function TransparentOverlay(props) {
  var _props_overlayMoreLink;
  return /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col md:grid md:grid-cols-2 h-full w-full items-center px-4 md:ps-10 md:pe-2 container-content"
  }, /*#__PURE__*/React.createElement("div", {
    className: "relative w-full md:h-1/2 h-60 md:min-h-[500px] md:max-h-[600px] overflow-hidden"
  }, /*#__PURE__*/React.createElement(Image, _object_spread_props(_object_spread({
    className: "absolute inset-0 w-full h-full"
  }, transformImageFragmentToProps(props.overlayImage, ["small", "medium", "large"])), {
    size: "large",
    fit: true
  }))), /*#__PURE__*/React.createElement("div", {
    className: "md:pe-10 py-10 px-7 md:py-12 md:ps-20 bg-primary-white max-md:rounded-t-7.5 md:rounded-l-7.5  md:h-1/2 md:min-h-[500px] md:max-h-[600px] max-md:-translate-y-8 md:-translate-x-8 flex items-center w-full"
  }, /*#__PURE__*/React.createElement(OverlayInfoBox, {
    title: props.overlayTitle,
    subtitle: props.overlaySubTitle,
    text: props.overlayText,
    url: (_props_overlayMoreLink = props.overlayMoreLink) === null || _props_overlayMoreLink === void 0 ? void 0 : _props_overlayMoreLink.url,
    linkLabel: props.overlayMoreText,
    ctaType: "link"
  })));
};
var OverlayInfoBox = function OverlayInfoBox(param) {
  var title = param.title,
    subtitle = param.subtitle,
    text = param.text,
    url = param.url,
    linkLabel = param.linkLabel,
    _param_ctaType = param.ctaType,
    ctaType = _param_ctaType === void 0 ? "button" : _param_ctaType;
  var t = useTranslation().t;
  return /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col gap-4 self-center"
  }, title && /*#__PURE__*/React.createElement("h2", {
    className: "font-juneau text-26 md:text-30 font-bold leading-125%"
  }, title), subtitle && /*#__PURE__*/React.createElement("p", {
    className: "font-juneau text-22 md:text-26 font-bold leading-125%"
  }, subtitle), text && /*#__PURE__*/React.createElement("div", {
    className: "font-juneau text-18 md:text-22 leading-normal"
  }, /*#__PURE__*/React.createElement(Html, {
    markup: text.replace(/(?:\r\n|\r|\n)/g, "<br>")
  })), url && /*#__PURE__*/React.createElement(React.Fragment, null, ctaType === "button" ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "hidden md:block"
  }, /*#__PURE__*/React.createElement(Button, {
    text: linkLabel !== null && linkLabel !== void 0 ? linkLabel : t("More"),
    href: url,
    icon: /*#__PURE__*/React.createElement(ArrowRight, null),
    variant: "primary",
    size: "large"
  })), /*#__PURE__*/React.createElement("div", {
    className: "block md:hidden"
  }, /*#__PURE__*/React.createElement(Button, {
    text: linkLabel !== null && linkLabel !== void 0 ? linkLabel : t("More"),
    href: url,
    icon: /*#__PURE__*/React.createElement(ArrowRight, null),
    variant: "primary",
    size: "medium"
  }))) : /*#__PURE__*/React.createElement(LinkItem, {
    text: linkLabel !== null && linkLabel !== void 0 ? linkLabel : t("More"),
    href: url,
    showIcon: true
  })));
};